import { render, staticRenderFns } from "./AccountViewNotes.vue?vue&type=template&id=18c4c0d2&"
import script from "./AccountViewNotes.vue?vue&type=script&lang=js&"
export * from "./AccountViewNotes.vue?vue&type=script&lang=js&"
import style0 from "./AccountViewNotes.vue?vue&type=style&index=0&id=18c4c0d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/AccountViewNotes.vue
// module id = null
// module chunks = 